const loadSprite = {
  init() {
    this.load();
  },

  async load() {
    const svg = document.getElementById("svg");
    if (!svg) return;

    const url = svg.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Failed to load SVG: ${response.status}`);
      }

      const html = await response.text();
      svg.innerHTML = html;
    } catch (error) {
      console.error("SVG sprite loading failed:", error);
    }
  },
};

export default loadSprite;
